import React from 'react';
import { Box } from '@mui/material';

function Logo({ size = 'medium', color = 'white' }) {
  const sizes = {
    small: { iconSize: 24, padding: 8 },
    medium: { iconSize: 32, padding: 10 },
    large: { iconSize: 40, padding: 12 },
  };

  const currentSize = sizes[size] || sizes.medium;
  const iconColor = color === 'white' ? '#ffffff' : '#5E7168';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: currentSize.iconSize + currentSize.padding * 2,
        height: currentSize.iconSize + currentSize.padding * 2,
      }}
    >
      <svg
        width={currentSize.iconSize}
        height={currentSize.iconSize}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Elegant scent waves icon */}
        <path
          d="M8 16C8 18.2091 9.79086 20 12 20C14.2091 20 16 18.2091 16 16C16 13.7909 14.2091 12 12 12C9.79086 12 8 13.7909 8 16Z"
          fill={iconColor}
          opacity="0.8"
        />
        <path
          d="M16 16C16 18.2091 17.7909 20 20 20C22.2091 20 24 18.2091 24 16C24 13.7909 22.2091 12 20 12C17.7909 12 16 13.7909 16 16Z"
          fill={iconColor}
          opacity="0.6"
        />
        {/* Wavy lines representing air flow */}
        <path
          d="M4 8C6 10 8 10 10 8"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
          opacity="0.7"
        />
        <path
          d="M22 8C24 10 26 10 28 8"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
          opacity="0.7"
        />
        <path
          d="M4 24C6 22 8 22 10 24"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
          opacity="0.7"
        />
        <path
          d="M22 24C24 22 26 22 28 24"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
          opacity="0.7"
        />
      </svg>
    </Box>
  );
}

export default Logo;

